import { Tab, Tabs } from '@mui/material'
import { TABS } from './boardShell'

// Next 3 Months and Months 4–18 (FAR-77 §4, FAR-83 §0: the Weekly tab is
// removed). Labels come from the plan's months ("Oct 2026 → Dec 2026"),
// falling back to the horizon names until the months load. The active tab has
// a green label and underline; inactive tabs are gray. Switching tabs changes
// only the horizon in view -- never the plan, its Base Plan or Modification.
export default function BoardTabs({ value, onChange, labels = {} }) {
  return (
    <Tabs
      value={value}
      onChange={(_, v) => onChange(v)}
      aria-label="Planning horizon"
      sx={{
        minHeight: 40,
        borderBottom: '1px solid',
        borderColor: 'divider',
        '& .MuiTab-root': { minHeight: 40, textTransform: 'none', fontWeight: 600, color: 'text.secondary' },
        '& .MuiTab-root.Mui-selected': { color: 'success.main' },
        '& .MuiTabs-indicator': { backgroundColor: 'success.main', height: 3 },
      }}
    >
      {TABS.map((t) => (
        <Tab key={t.key} value={t.key} label={labels[t.key] || t.label} aria-label={t.label} />
      ))}
    </Tabs>
  )
}
